var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineHomeWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0756F0F2-8E64-4AAE-A6D0-0E3C10C814A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional",
    transform: "translate(-108.000000, -764.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-wifi",
    transform: "translate(108.000000, 764.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39982986,22.5598946 C4.57982981,22.5598946 2.91983086,21.1598213 2.61983085,19.3598213 L1.28984433,11.3998613 C1.07984433,10.1598613 1.67984915,8.56986624 2.66984916,7.77986622 L9.59984207,2.22981721 C10.9398421,1.14981717 13.0498298,1.15982693 14.3998299,2.23982698 L21.3298225,7.77986622 C22.3098226,8.56986624 22.9098274,10.1598613 22.7098274,11.3998613 L21.3798409,19.3598213 C21.0798408,21.1298213 19.389842,22.5598946 17.5998421,22.5598946 L6.39982986,22.5598946 Z M10.5398445,3.40987098 L3.60982108,8.95979786 C3.03982109,9.41979787 2.64982475,10.4398711 2.76982474,11.1598711 L4.09984183,19.1198311 C4.27984184,20.169831 5.32982981,21.0598946 6.39982986,21.0598946 L17.5998421,21.0598946 C18.6698421,21.0598946 19.7198299,20.1698213 19.8998299,19.1098213 L21.229847,11.1498613 C21.349847,10.4298613 20.9498506,9.39978808 20.3898506,8.94978809 L13.4598274,3.40987098 C13.0598274,3.09987098 12.5298262,2.93977821 11.9898262,2.93977821 C11.4598262,2.93977821 10.9298445,3.09987098 10.5398445,3.40987098 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.600544,14.9199903 C12.6305439,13.9899903 11.3705523,13.9899903 10.3905523,14.9199903 C10.0905523,15.2099903 9.62052421,15.1999708 9.33052422,14.8999708 C9.04052423,14.5999708 9.05054374,14.1299122 9.35054375,13.8399122 C10.9005437,12.3499122 13.0705428,12.3499122 14.6305428,13.8399122 C14.9305428,14.1299122 14.9405318,14.5999708 14.6505318,14.8999708 C14.5205318,15.0499708 14.320533,15.1299512 14.120533,15.1299512 C13.930533,15.1299512 13.750544,15.0599903 13.600544,14.9199903 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7203722,12.8000829 C15.2503722,12.3400829 14.7203746,11.9699853 14.1603746,11.6999853 C12.7603747,11.0299852 11.2303675,11.0299852 9.84036756,11.6999853 C9.28036755,11.9699853 8.76036999,12.3400829 8.28037,12.8000829 C7.99037001,13.0900829 7.51037237,13.0900732 7.22037238,12.7900732 C6.93037239,12.4900731 6.94038215,12.0200146 7.23038214,11.7300146 C7.82038212,11.1500146 8.48037368,10.6900098 9.19037366,10.3500098 C11.0003736,9.48000979 13.0003588,9.48000979 14.8003588,10.3500098 C15.5103588,10.6900098 16.1703808,11.1500146 16.7603807,11.7300146 C17.0603808,12.0200146 17.06036,12.4900731 16.77036,12.7900732 C16.63036,12.9300732 16.4403612,13.0100439 16.2403612,13.0100439 C16.0503612,13.0100439 15.8603722,12.9400829 15.7203722,12.8000829 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2905469,17.2099805 C10.9005469,16.8199805 10.9005469,16.1900683 11.2905469,15.8000683 C11.6805468,15.4100684 12.3205298,15.4100684 12.7105298,15.8000683 C13.1005298,16.1900683 13.1005298,16.8199805 12.7105298,17.2099805 C12.5105298,17.3999805 12.2605383,17.5000196 12.0005383,17.5000196 C11.7405384,17.5000196 11.4905469,17.3999805 11.2905469,17.2099805 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHomeWifi);
export default __webpack_public_path__ + "static/media/vuesax-outline-home-wifi.a65db26a7041875c4ce92cfb22b2ee4d.svg";
export { ForwardRef as ReactComponent };